import './styles.scss'
import { BUTTON_TYPE } from './types'

export type ButtonProps = {
  text: string
  classPrefix?: string
  disabled?: boolean
  type?: BUTTON_TYPE
  onClick: () => void
}

const CLASS_NAME = 'gby-k2g-button'

export const Button = ({ type, classPrefix, onClick, disabled, text }: ButtonProps) => {
  const classSuffix = type === BUTTON_TYPE.SUBMIT ? '-submit' : ''

  return (
    <button
      className={`${CLASS_NAME}${classSuffix}${classPrefix ? ` ${classPrefix}${classSuffix}` : ''}`}
      disabled={disabled ?? false}
      onClick={onClick}>
      {text}
    </button>
  )
}
